import { Box, HStack, VStack, Text, Image, Badge, Button } from "@chakra-ui/react";
import {useNavigate} from "react-router-dom";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";

const ModelCard = ({ title, status, description, avatarUrl, buttonUrl }) => {
    const {t} = useTranslation("common");
    const navigate = useNavigate();

    const statusStyles = useMemo(() => {
        if(status) {
            return {
                bg:"green.500",
                borderColor: "green.200",
            }
        }
        
        return {
            bg:"orange.500",
            borderColor: "orange.200",
        }
    }, [status]);


    const statusLabel = useMemo(() => {
        if(status) {
            return t("status.active")
        }

        return t("status.inactive")
    }, [status, t]);

    return (
        <Box
            bg="bg.card"
            border="1px solid"
            borderColor="border.primary"
            borderRadius={12}
            p={5}
        >
            <VStack align="flex-start" justify="space-between" gap={1}>
                <HStack gap={4} align="flex-start" flex={1}>
                    <Image
                        src={avatarUrl}
                        boxSize="80px"
                        borderRadius={8}
                        objectFit="cover"
                        flexShrink={0}
                    />
                    <VStack align="flex-start" gap={2}>
                        <HStack gap={3} align="center">
                            <Text fontWeight={700} fontSize="xl" color="white">
                                {title}
                            </Text>
                            {/*<Badge*/}
                            {/*    {...statusStyles}*/}
                            {/*    borderWidth={1}*/}
                            {/*    variant="subtle"*/}
                            {/*    fontSize="xs"*/}
                            {/*    px={4}*/}
                            {/*    py={0.5}*/}
                            {/*    borderRadius={6}*/}
                            {/*>*/}
                            {/*    {statusLabel}*/}
                            {/*</Badge>*/}
                        </HStack>
                        <Text color="text.grey" fontSize="sm" maxW="420px" lineHeight={1.6}>
                            {description}
                        </Text>
                    </VStack>
                </HStack>
                <Button
                    variant="primary"
                    alignSelf="flex-end"
                    flexShrink={0}
                    onClick={() => navigate(buttonUrl)}
                >
                    {t("actions.details")}
                </Button>
            </VStack>
        </Box>
    );
};

export default ModelCard;
